require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-krensdorf.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-krensdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-krensdorf!./.cache/json/betreuungseinrichtungen-mattersburg-krensdorf.json
// module id = 929
// module chunks = 231608221292675